package com.partejar.app.core.ui.components

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.material3.IconButton
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier

/** Keeps Material focus, semantics and touch targets, with the same feedback as PartejarButton. */
@Composable
fun PartejarIconButton(onClick: () -> Unit, modifier: Modifier = Modifier, enabled: Boolean = true, content: @Composable () -> Unit) {
    val interaction = remember { MutableInteractionSource() }
    val pressed by interaction.collectIsPressedAsState()
    IconButton(onClick, modifier.partejarPressFeedback(pressed, enabled), enabled = enabled,
        interactionSource = interaction, content = content)
}
